import useLabel from "@apps/use-label/use-label";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

import AskAIPlaceholderSuggestedArtifact from "./ask-ai-placeholder-suggested-artifact";

const AskAIPlaceholderSuggestedGoal = ({ title }: { title: string }) => {
  const label = useLabel();
  return (
    <AskAIPlaceholderSuggestedArtifact
      label={`Create ${label("goal", { titleCase: true })}`}
      title={title}
      icon={<TopicflowIcon type="goal" className="text-gray-500 h-5 w-5" />}
    />
  );
};

export default AskAIPlaceholderSuggestedGoal;
